// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__1JKHX","cell":"NotFound_cell__3HiIa","txt":"NotFound_txt__2YSts","link":"NotFound_link__2QWan"};